import Sidebar from "../../components/sidebar/Sidebar";
import Topbar from "../../components/topbar/Topbar";
import Searchbar from "../../components/searchBar/Searchbar";
import style from "./Usuario.module.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { MdDelete, MdEdit, MdSearch, MdClose } from "react-icons/md";
import UsuarioApi from "../../services/UsuarioApi";
import GrupoDeUsuarioApi from "../../services/GrupoDeUsuarioApi";
import { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { Form } from "react-bootstrap";
import Alerta from "../../components/alerta/Alerta";
import BotaoNovo from "../../components/botaoNovo/BotaoNovo";
import Paginacao from "../../components/paginacao/Paginacao";
import Loader from "../../components/loader/Loader";
import InputBuscar from "../../components/inputBuscar/InputBuscar";
import { useIsMobile } from "../../components/useIsMobile/UseIsMobile";

function Usuario() {
  //Usuario selecionado para editar ou excluir
  const [usuarioSelecionado, setUsuarioSelecionado] = useState(null);

  //Modais para adicionar, editar e excluir
  const [mostarModalDeletar, setMostarModalDelatar] = useState(false);
  const [mostarModalEditar, setMostarModalEditar] = useState(false);

  const isMobile = useIsMobile();
  const [menuHamburguerAberto, setMenuHamburguerAberto] = useState(!isMobile);

  useEffect(() => {
    setMenuHamburguerAberto(!isMobile);
  }, [isMobile]);

  //Para rodar a tabela, paginação e filtro
  const [usuarios, setUsuarios] = useState([]);
  const [quantidadeItens, setQuantidadeItens] = useState(0);
  const [nome, setNome] = useState("");
  const [email, setEmail] = useState("");
  const [nomeFiltro, setNomeFiltro] = useState("");
  const [emailFiltro, setEmailFiltro] = useState("");
  const [paginaAtual, setPaginaAtual] = useState(1); //estado inicial da pagina

  //Para exibir o alerta
  const [mostrarAlerta, setMostrarAlerta] = useState(false);
  const [mensagemAlerta, setMensagemAlerta] = useState("");
  const [tipoAlerta, setTipoAlerta] = useState("");

  //Carregar dados iniciais
  const [statusUsuarios, setStatusUsuarios] = useState([]);

  const [loading, setLoading] = useState(false);

  //Função para exibir o alerta
  const exibirAlerta = () => {
    setMostrarAlerta(true);
    setTimeout(() => {
      setMostrarAlerta(false);
    }, 10000);
  };

  //Função para abrir o modal de editar
  const handleClickEditar = (usuario) => {
    setUsuarioSelecionado(usuario);
    setMostarModalEditar(true);
  };

  //Função para abrir o modal de deletar
  const handleClickDeletar = (usuario) => {
    setUsuarioSelecionado(usuario);
    setMostarModalDelatar(true);
  };


  const handleEditar = async () => {
    try {
      setLoading(true);
      await UsuarioApi.AtualizarUsuarioAsync(usuarioSelecionado);
      CarregarUsuarios(1, nomeFiltro, emailFiltro);
      setMensagemAlerta(`Usuário atualizado com sucesso!`);
      setTipoAlerta("success");
      exibirAlerta(true);
    } catch (error) {
      setMensagemAlerta(`Erro ao atualizar usuário: ${error.response.data}`);
      setTipoAlerta("danger");
      exibirAlerta(true);
    } finally {
      handleFecharModal();
      setLoading(false);
    }
  };

  const handleDeletar = async () => {
    try {
      setLoading(true);
      await UsuarioApi.DeletarUsuarioAsync(usuarioSelecionado.usuarioID);
      CarregarUsuarios();
      setMensagemAlerta(`Usuário deletado com sucesso!`);
      setTipoAlerta("success");
      exibirAlerta(true);
    } catch (error) {
      setMensagemAlerta(`Erro ao deletar usuário: ${error.response.data}`);
      setTipoAlerta("danger");
      exibirAlerta(true);
    } finally {
      handleFecharModal();
      setLoading(false);
    }
  };

  const handleFecharModal = () => {
    setMostarModalDelatar(false);
    setMostarModalEditar(false);
    setUsuarioSelecionado(null);
  };

  async function BuscarStatusUsuarios() {
    try {

      const status = await UsuarioApi.ListarStatusUsuarioAsync();
      setStatusUsuarios(status);

    } catch (error) {
      console.error("Erro ao buscar status do usuário:", error.response.data);
    } finally {

    }
  }

  async function AlterarPagina(paginaNova) {
    setPaginaAtual(paginaNova);
    await CarregarUsuarios(paginaNova, nomeFiltro, emailFiltro);
  }

  //Função para filtro de busca
  async function BuscarUsuarios() {
    setPaginaAtual(1);
    await CarregarUsuarios(1, nomeFiltro, emailFiltro);
  }

  //Função para resetar  filtro de busca
  async function ResetarUsuarios() {
    setNome("");
    setEmail("");
    setNomeFiltro("");
    setEmailFiltro("");
    setPaginaAtual(1);
    await CarregarUsuarios(1, "", "");
  }

  //Função para carregar os usuarios
  const CarregarUsuarios = async (paginaAtual, nome, email) => {
    try {

      const listaUsuarios = await UsuarioApi.ListarUsuariosComPaginacaoAsync(
        paginaAtual,
        nome,
        email
      );
      setQuantidadeItens(listaUsuarios.quantidadeRegistros);
      setUsuarios(listaUsuarios.registros);
    } catch (error) {

      console.error("Erro ao carregar usuários:", error.response.data);
    } finally {

    }
  }

  const totalPages = Math.ceil(quantidadeItens / 10); //total de paginas com itens filtrados

  useEffect(() => {
    BuscarStatusUsuarios();
  }, []);

  useEffect(() => {
    CarregarUsuarios(1, nomeFiltro, emailFiltro);
  }, []);


  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const alertParam = params.get("alert");

    if (alertParam === "logado_sucesso") {
      setMensagemAlerta("Logado com sucesso!");
      setTipoAlerta("success");

      // Aguarda o próximo ciclo de renderização para aplicar classe de alerta
      setTimeout(() => {
        setMostrarAlerta(true);
      }, 100); // um pequeno delay

      params.delete("alert");
      navigate({ search: params.toString() }, { replace: true });

      setTimeout(() => setMostrarAlerta(false), 3000);
    }
  }, [location, navigate]);

  return (
    <Sidebar menuHamburguerAberto={menuHamburguerAberto} setMenuHamburguerAberto={setMenuHamburguerAberto}>
      <Topbar menuHamburguerAberto={menuHamburguerAberto} setMenuHamburguerAberto={setMenuHamburguerAberto}>
        <Alerta
          tipo={tipoAlerta}
          mensagem={mensagemAlerta}
          visivel={mostrarAlerta}
          aoFechar={() => setMostrarAlerta(false)}
        />
        {loading && <Loader />}
        <div className={style.alertLogado}>
          {mostrarAlerta && (
            <Alerta
              variant={tipoAlerta}
              onClose={() => setMostrarAlerta(false)}
              dismissible
              className={style.alertaBaixoDireito}
            >
              {mensagemAlerta}
            </Alerta>

          )}

        </div>
        <div className={style.pagina_conteudo}>
          {/* Cabeçalho da pagina */}
          <div className={style.container_cabecalho}>
            <h4>Usuarios</h4>
            <BotaoNovo link={"/backoffice/usuario/novo"} />
          </div>

          {/* Filtro de pesquisa */}
          <div className={style.container_filtro}>
            <InputBuscar
              type="text"
              id="hidenNome"
              placeholder="Nome"
              name="nome"
              maxLength={30}
              value={nomeFiltro}
              onChange={(e) => setNomeFiltro(e.target.value)}
            />

            <InputBuscar
              type="text"
              id="hidenEmail"
              placeholder="Email"
              name="email"
              maxLength={50}
              value={emailFiltro}
              onChange={(e) => setEmailFiltro(e.target.value)}
            />
            <div className={style.container_filtro2}>
              <Button onClick={BuscarUsuarios} id={style.botao_buscar}><MdSearch /> Buscar
              </Button>

              <Button onClick={ResetarUsuarios} id={style.botao_resetar}><MdClose /> Limpar
              </Button>
            </div>


          </div>

          {/* Tabela com paginação */}
          <div className={style.container_tabela_paginacao}>
            <div className={style.tabela_responsiva}>
              <table className={style.container_tabela}>
                <thead>
                  <tr>
                    <th>Nome</th>
                    <th>Email</th>
                    <th>Último login</th>
                    <th>Status</th>
                    <th className={style.coluna_acoes}>Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {usuarios.map((usuario) => (
                    <tr className={style.tabela_corpo} key={usuario.usuarioID}>
                      <td title={usuario.nomeCompleto}>{usuario.nomeCompleto}</td>
                      <td title={usuario.email}>{usuario.email}</td>
                      <td title={usuario.dataUltimoLogin}>{new Date(usuario.dataUltimoLogin).toLocaleDateString('pt-BR', {
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric'
                      })}{' '}
                        {new Date(usuario.dataUltimoLogin).toLocaleTimeString('pt-BR', {
                          hour: '2-digit',
                          minute: '2-digit'
                        })}
                      </td>
                      <td title={statusUsuarios.find(s => s.id === usuario.status)?.nome}>{statusUsuarios.find(s => s.id === usuario.status)?.nome}</td>
                      <td className={style.coluna_acoes}>
                        <Link
                          onClick={() => handleClickEditar(usuario)}
                          className={style.botao_editar}
                        >
                          <MdEdit
                            title="Editar" />
                        </Link>
                        <Link
                          onClick={() => handleClickDeletar(usuario)}
                          className={style.botao_deletar}
                        >
                          <MdDelete
                            title="Deletar" />
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            {/* Controle de Paginação */}
            <Paginacao
              id={style.configuracao_paginacao}
              paginaAtual={paginaAtual}
              totalPages={totalPages}
              onPageChange={(novaPagina) => AlterarPagina(novaPagina)}
            />
          </div>

          {/* Modal de confirmação */}
          <Modal show={mostarModalDeletar} onHide={handleFecharModal}>
            <Modal.Header closeButton>
              <Modal.Title>Confirmar</Modal.Title>
            </Modal.Header>

            <Modal.Body>
              Tem certeza que deseja deletar o usuário{" "}
              {usuarioSelecionado?.nomeCompleto}?
            </Modal.Body>

            <Modal.Footer>
              <Button variant="secondary" onClick={handleFecharModal}>
                Cancelar
              </Button>
              <Button variant="danger" onClick={handleDeletar}>
                Deletar
              </Button>
            </Modal.Footer>
          </Modal>

          <Modal show={mostarModalEditar} onHide={handleFecharModal}>
            <Modal.Header closeButton>
              <Modal.Title>Editar Usuário</Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <Form>
                <Form.Group controlId="formNomeCompleto" className="mb-3">
                  <Form.Label>Nome Completo</Form.Label>
                  <InputBuscar
                    maxLength={100}
                    type="text"
                    placeholder="Digite seu nome completo"
                    name="nomeCompleto"
                    value={usuarioSelecionado?.nomeCompleto || ""}
                    onChange={(e) =>
                      setUsuarioSelecionado({
                        ...usuarioSelecionado,
                        [e.target.name]: e.target.value,
                      })
                    }
                    required
                  />
                </Form.Group>

                <Form.Group controlId="formStatusUsuario" className="mb-3">
                  <Form.Label>Status do Usuário</Form.Label>
                  <Form.Control
                    as="select"
                    name="statusUsuario"
                    value={usuarioSelecionado?.status || ""}
                    onChange={(e) =>
                      setUsuarioSelecionado({
                        ...usuarioSelecionado,
                        status: e.target.value,
                      })
                    }
                    required
                  >
                    {statusUsuarios.map((statusUsuario) => (
                      <option key={statusUsuario.id} value={statusUsuario.id}>
                        {statusUsuario.nome}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Form>
            </Modal.Body>

            <Modal.Footer>
              <Button variant="secondary" onClick={handleFecharModal}>
                Cancelar
              </Button>

              <Button variant="danger" onClick={handleEditar}>
                Atualizar
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </Topbar>
    </Sidebar>
  );
}
export default Usuario;
